import type { Image, Score } from "../..";

interface Choice {
	id: string;
	text: string;
	isCorrect?: boolean;
	explanation?: string;
	stem: string;
	images?: Image[];
}

enum QuestionVariant {
	mcq = "MCQ",
	sata = "SATA",
	speaking = "speaking",
	writing = "WRITING",
	listening = "listening",
	readingprose = "readingprose",
	readingchart = "readingdocuments",
	hotspots = "hotspot",
	quantitative = "quantitative",
	essaygrading = "essayGrading",
	audioResponse = "audioResponse",
	sequence = "sequence",
	textAnswer = "textAnswer",
	audioAnswer = "audioAnswer",
	markingAnswer = "markingAnswer",
	essayGrading = "essayGrading",
	vocabulary = "VOCABULARY",
	conversation = "CONVERSATION",
	mcmsH = "Multiple Choice Multiple Selection with Highlight (MCMSH)",
}
interface Question {
	id: string;
	children: Choice[];
	stem: string;
	prompt?: string;
	images?: Image[];
	variant?: QuestionVariant;
	currentScore?: Score;
}

export { type Question, QuestionVariant };
